import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function About() {
  const { ref: sectionRef, inView: isInView } = useInView({ threshold: 0.3 });

  return (
    <section
      ref={sectionRef}
      className="relative py-24 px-6 md:px-16 overflow-hidden min-h-screen flex items-center"
      style={{
        background: 'linear-gradient(135deg, #041c38 100%,#031223 0%)',
      }
	}
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-cyan-500 opacity-10 blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.1, 0.15, 0.1]
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-1/3 right-1/4 w-80 h-80 rounded-full bg-purple-600 opacity-10 blur-3xl"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.1, 0.2, 0.1]
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2
          }}
        />
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <motion.div 
          className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-24"
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }} 
          transition={{ duration: 0.8 }}
        >
          {/* Text Content */}
          <div className="flex-1">
            <motion.div
              className="mb-8"
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                KNOW WHO <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">I'M</span>
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-purple-500 rounded-full"></div>
            </motion.div>

            <motion.div
              className=" text-base md:text-lg lg:text-xl leading-relaxed space-y-4"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <p className='text-white'>
                The mastermind behind the innovative <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent font-medium">Necttos app</span>, a groundbreaking educational platform designed specifically to enhance the college education experience.
              </p>
              <p className='text-white'>
                Through his vision and commitment to improving learning outcomes, <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent font-medium">Uvais</span> has developed an app that serves as a comprehensive resource for students and teachers, offering tools and features that streamline the academic journey.
              </p>
              <p className='text-white'>
                Necttos has quickly become a game-changer in the world of higher education, empowering students and educators alike with a dynamic, user-friendly platform that fosters academic success.
              </p>
            </motion.div>
          </div>

          {/* Image Content */}
          <motion.div
            className="flex-1 relative w-full max-w-md"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="relative">
              {/* Main image with gradient border */}
              <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-cyan-500 to-purple-600 opacity-20 blur-md"></div>
              <motion.img
                src="https://static.vecteezy.com/system/resources/thumbnails/024/354/252/small/businessman-isolated-illustration-ai-generative-free-photo.jpg"
                alt="Uvais KT"
                className="relative rounded-xl w-full h-auto object-cover shadow-2xl border border-gray-800/50"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              />
              
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full bg-cyan-500/10 blur-lg"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-purple-500/10 blur-lg"></div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}